module.exports = __webpack_public_path__ + "static/media/Imagen_3.16bf32eb.png";